import { Controller, useFormContext } from 'react-hook-form'

import { Badge } from '@wartek-id/badge'
import { Button } from '@wartek-id/button-v1'
import { Icon } from '@wartek-id/icon-v2'
import { Text } from '@wartek-id/text-v1'

import {
  TableBody,
  TableHeader,
  TableHeaderItem,
  TablePelaksanaanKinerja,
  TableRow,
  TableRowItem,
} from 'app/KinerjaShared/components/TablePelaksanaanKinerja'
import {
  INDICATOR_GROUP_BADGES,
  INDICATOR_REFERENSI_KOMPETENSI_KEYS,
} from 'app/KinerjaPSPegawaiPage/constants/pengembanganKompetensi'
import { useIndikatorKompetensi } from 'app/KinerjaPSPegawaiPage/hooks/useIndikatorKompetensi'
import { usePerencanaanPS } from 'app/KinerjaPSPegawaiPage/hooks/usePerencanaan'

export const IndicatorsForm = () => {
  const { control } = useFormContext()

  const { indikatorKompetensiData, isReferensiKompetensi } =
    useIndikatorKompetensi()
  const { isPengembanganKompetensiEditable } = usePerencanaanPS()

  return (
    <Controller
      control={control}
      name="indicator"
      rules={{
        required: true,
      }}
      render={({ field: { onChange, value } }) => {
        const selectedIndicator = Object.values(indikatorKompetensiData)
          .flat()
          .find(({ indikatorId }) => indikatorId === value)

        return (
          <div className="space-y-4">
            <Text variant="heading-md">
              Pilih 1 Indikator untuk menjadi fokus peningkatan kinerja Anda
            </Text>

            {!Boolean(selectedIndicator) && (
              <Text color="subdued">
                Anda tetap diharapkan untuk meningkatkan semua Indikator, 1
                Indikator yang dipilih hanya untuk fokus Pengelolaan Kinerja
                saja.
              </Text>
            )}
            <TablePelaksanaanKinerja className="mt-0 border border-subdued">
              {!Boolean(selectedIndicator) && (
                <TableHeader>
                  <TableHeaderItem colSpan={3}>
                    <Text variant="body" color="default" className="!font-bold">
                      Daftar Indikator{' '}
                      {isReferensiKompetensi &&
                        'berdasarkan hasil Refleksi Kompentensi Anda'}
                    </Text>
                  </TableHeaderItem>
                </TableHeader>
              )}
              <TableBody>
                {Boolean(selectedIndicator) ? (
                  <>
                    <TableRow className="bg-surface-selected-default">
                      <TableRowItem className="flex-none align-middle">
                        <Text
                          variant="helper-bold"
                          color="informational"
                          className="w-24 overflow-wrap-anywhere"
                        >
                          {selectedIndicator.section}
                        </Text>
                      </TableRowItem>
                      <TableRowItem className="pl-0 align-middle">
                        <Text
                          variant="body"
                          color="default"
                          className="overflow-wrap-anywhere"
                        >
                          {selectedIndicator.deskripsi}
                        </Text>
                      </TableRowItem>
                      <TableRowItem className="flex justify-end pl-0 space-x-4 align-middle">
                        <div className="flex items-center space-x-1">
                          <Icon color="success" fontSize="sm">
                            check
                          </Icon>
                          <Text color="success" variant="body-sm-bold">
                            Dipilih
                          </Text>
                        </div>
                        {isPengembanganKompetensiEditable && (
                          <Button
                            color="white"
                            size="sm"
                            className="!bg-transparent"
                            onClick={() => onChange(undefined)}
                          >
                            Ubah
                          </Button>
                        )}
                      </TableRowItem>
                    </TableRow>
                  </>
                ) : (
                  <>
                    {Object.keys(indikatorKompetensiData).map((key, index) => {
                      return (
                        <>
                          {INDICATOR_REFERENSI_KOMPETENSI_KEYS.includes(key) &&
                            (indikatorKompetensiData?.[key] ?? []).length >
                              0 && (
                              <TableRow
                                key={`table-row-${index}`}
                                className="bg-white"
                              >
                                <TableRowItem
                                  colSpan={3}
                                  className="align-middle"
                                >
                                  <Badge
                                    variant={
                                      INDICATOR_GROUP_BADGES?.[key]?.variant ??
                                      'neutral'
                                    }
                                  >
                                    {INDICATOR_GROUP_BADGES?.[key]?.title ??
                                      key}
                                  </Badge>
                                </TableRowItem>
                              </TableRow>
                            )}

                          {indikatorKompetensiData[key].map(
                            ({ indikatorId, section, deskripsi }, subIndex) => {
                              return (
                                <TableRow
                                  key={`table-row-${subIndex}`}
                                  className="bg-white"
                                >
                                  <TableRowItem className="align-middle">
                                    <Text
                                      variant="helper-bold"
                                      color="informational"
                                      className="w-24 overflow-wrap-anywhere"
                                    >
                                      {section}
                                    </Text>
                                  </TableRowItem>
                                  <TableRowItem className="pl-0 align-middle">
                                    <Text
                                      variant="body"
                                      color="default"
                                      className="overflow-wrap-anywhere"
                                    >
                                      {deskripsi}
                                    </Text>
                                  </TableRowItem>
                                  <TableRowItem className="flex justify-end pl-0 align-middle">
                                    <Button
                                      data-testid="choose-indicator-button"
                                      color="white"
                                      size="sm"
                                      onClick={() => onChange(indikatorId)}
                                    >
                                      Pilih
                                    </Button>
                                  </TableRowItem>
                                </TableRow>
                              )
                            }
                          )}
                        </>
                      )
                    })}
                  </>
                )}
              </TableBody>
            </TablePelaksanaanKinerja>
          </div>
        )
      }}
    />
  )
}
